import { getLoginToken } from "./helperMethods";

class API {
  defaultHeaders = () => ({
    Accept: "application/json",
    Authorization: `Bearer ${getLoginToken()}`,
  });

  async #request({
    url,
    params = {},
    method = "GET",
    responseType = "json",
    requestAbortSignal,
  }) {
    let URL = url;

    const options = {
      method,
      headers: this.defaultHeaders(),
      responseType,
    };

    if (requestAbortSignal) {
      options.signal = requestAbortSignal;
    }

    if (method === "GET") {
      URL = Object.keys(params).length
        ? `${url}?${new URLSearchParams(params).toString()}`
        : url;
    } else {
      options.body =
        params instanceof FormData ? params : JSON.stringify(params);
    }

    const response = await fetch(URL, options);

    return response.json();
  }

  get = (url, params, requestAbortSignal) =>
    this.#request({ url, params, requestAbortSignal });

  post = (url, params) => this.#request({ url, params, method: "POST" });

  put = (url, params) => this.#request({ url, params, method: "PUT" });

  delete = (url, params) => this.#request({ url, params, method: "DELETE" });
}

export default API;
